/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useEffect, useState} from "react";
import {useTypedSelector} from "helpers/reducers";
import {PackageCategory} from "types/enums/PackageCategory";
import {RouteComponentProps, withRouter} from "react-router";
import BookingPackagesEvent from "pages/Front/Booking/BookingPackagesEvent";
import BookingPackagesBasic from "pages/Front/Booking/BookingPackagesBasic";
import SettingsAction from "store/settings/SettingsAction";
import {useDispatch} from "useDispatch";
import BookingPackagesEventSchoolTrophy from "pages/Front/Booking/BookingPackagesEventSchoolTrophy";

export interface Params {}

interface BookingPackagesNewProps extends RouteComponentProps<Params> {}

const BookingPackagesNew = (props: BookingPackagesNewProps) => {
    const dispatch = useDispatch();
    const filter = useTypedSelector(state => state.bookingState.bookingProcess.filter);
    const [isLoadingSettings, setIsLoadingSettings] = useState<boolean>(false);

    const fetchSettings = () => {
        dispatch(SettingsAction.fetchSettings())
            .then(() => {})
            .finally(() => {
                setIsLoadingSettings(false);
            });
    };

    const timerToLoadSettings = () => {
        if (isLoadingSettings) {
            return;
        }

        setIsLoadingSettings(true);
        fetchSettings();

        setTimeout(() => {
            setIsLoadingSettings(false);
            timerToLoadSettings();
        }, 30 * 1000);
    };

    useEffect(() => {
        timerToLoadSettings();
    }, []);

    if (filter.category === PackageCategory.SchoolTrophy || filter.category === PackageCategory.MegaFunSchool) {
        return <BookingPackagesEventSchoolTrophy />;
    }

    return (
        <>
            {filter.category === PackageCategory.EventS ||
            filter.category === PackageCategory.EventM ||
            filter.category === PackageCategory.EventL ||
            filter.category === PackageCategory.PolterabendNonPlusUltra ||
            filter.category === PackageCategory.PolterabendMegaFun ||
            filter.category === PackageCategory.EventMegaFun ||
            filter.category === PackageCategory.EventNonPlusUltra ? (
                <BookingPackagesEvent />
            ) : (
                <BookingPackagesBasic />
            )}
        </>
    );
};

export default withRouter(BookingPackagesNew);
